import React from "react";
import ButtonCore from "../ButtonCore";
import { IButtonUIInterface } from "../interface";

const SoftButton: React.FC<React.PropsWithChildren<IButtonUIInterface>> = (props) => {
  return <ButtonCore type="soft" {...props} />;
};

export default SoftButton;
